import { dateFromString } from '@retail/utils';
import { ConditionBindingMinimal, MarkupConditionNewDTO } from '../../dtos/ConditionsNewDTO';

export interface MarkupBinding {
  coverageDegree: number;
  salesFactor: number;
  isInherited: boolean;
  bindingInfo: ConditionBindingMinimal;
}
interface MarkupConditionProps {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  costFactor?: number;
  coverageDegree: number;
  salesFactor: number;
  validFrom: Date;
  validTo?: Date;
}

export class MarkupConditionNew {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  costFactor?: number;
  coverageDegree: number;
  salesFactor: number;
  validFrom: Date;
  validTo?: Date;

  constructor({
    conditionId,
    isInherited,
    inheritedBinding,
    isDeletionCondition,
    costFactor,
    coverageDegree,
    salesFactor,
    validFrom,
    validTo,
  }: MarkupConditionProps) {
    this.conditionId = conditionId;
    this.isInherited = isInherited;
    this.inheritedBinding = inheritedBinding;
    this.isDeletionCondition = isDeletionCondition;
    this.costFactor = costFactor;
    this.coverageDegree = coverageDegree;
    this.salesFactor = salesFactor;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  static fromDto = (dto: MarkupConditionNewDTO): MarkupConditionNew => {
    return new MarkupConditionNew({
      conditionId: dto.conditionId,
      isInherited: dto.isInherited,
      inheritedBinding: dto.inheritedBinding,
      isDeletionCondition: dto.isDeletionCondition,
      costFactor: dto.costFactor,
      coverageDegree: dto.coverageDegree,
      salesFactor: dto.salesFactor,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
    });
  };
}
